module.exports = __webpack_public_path__ + "static/media/price-tag.a3d1d236.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/price-tag.svg
// module id = 746
// module chunks = 0